import { render, staticRenderFns } from "./BaseTaskPanel.vue?vue&type=template&id=1d3ef006&scoped=true"
import script from "./BaseTaskPanel.vue?vue&type=script&lang=js"
export * from "./BaseTaskPanel.vue?vue&type=script&lang=js"
import style0 from "./BaseTaskPanel.vue?vue&type=style&index=0&id=1d3ef006&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3ef006",
  null
  
)

export default component.exports